

























import { Component, Vue, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { assignLicencesToUser } from "@/data/repository/UserRepository";

import User from "@/data/models/User";
import { Licence } from "@/data/models/Licence";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
  },
})
export default class SelectLicencesComponent extends Vue {
  user!: User;

  allLicences = [
    Licence.BASIC_LICENCE,
    Licence.DRYING_PROJECT_LICENCE,
    Licence.LEAK_DETECTION_PROJECT_LICENCE,
  ];
  selectedLicences = [Licence.BASIC_LICENCE];

  missingLicencesError: string | null = null;

  getLicenceName(licence: Licence) {
    switch (licence) {
      case Licence.BASIC_LICENCE:
        return this.$t("assignLicences.basic");
      case Licence.DRYING_PROJECT_LICENCE:
        return this.$t("assignLicences.drying");
      case Licence.LEAK_DETECTION_PROJECT_LICENCE:
        return this.$t("assignLicences.leakDetection");
    }
  }

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  async show(user: User) {
    this.user = user;

    this.baseDialogComponent.show({
      title: this.$t("assignLicences.selectLicences").toString(),
      positiveButtonText: this.$t("common.save").toString(),
      negativeButtonText: null,
      closeOnSave: false,
      persistent: true,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    this.missingLicencesError = null;
    this.baseDialogComponent.loading = true;
    const result = await assignLicencesToUser(
      this.user.id,
      this.selectedLicences
    );
    this.baseDialogComponent.loading = false;

    if (result.wasSuccessful) {
      this.baseDialogComponent.isShowing = false;
    } else if (result.missingLicences.length > 0) {
      this.missingLicencesError = this.$t(
        "assignLicences.errorMissingLicences",
        [
          result.missingLicences
            .map((licence) => this.getLicenceName(licence as Licence))
            .join(", "),
        ]
      ).toString();
    }
  }
}
